import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from '~/services/api/baseQuery';

import { ARTIFACTS_API_TAGS } from '../artifacts/artifacts.constants';
import { COMPONENTS_API_TAGS } from '../components/components.constants';
import { STEPS_API_TAGS } from '../steps/steps.constants';
import { TESTS_API_TAGS } from '../tests/tests.constants';

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: axiosBaseQuery({ baseUrl: '' }),
  tagTypes: [
    ...Object.values(TESTS_API_TAGS),
    ...Object.values(STEPS_API_TAGS),
    ...Object.values(ARTIFACTS_API_TAGS),
    ...Object.values(COMPONENTS_API_TAGS),
  ],
  endpoints: () => ({}),
});
